import ModalInTailwind from '$components/ModalInTailwind/ModalInTailwind';
import ModalCandidateActions from '$components/Positions/CandidateSummaryCardList/CandidateSummaryCard/CandidateSummaryCardEmployers/ModalCandidateActions/ModalCandidateActions';
import { useAppDispatch } from '$hooks/use-app-dispatch.hook';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import { singlePositionSlice } from '$store/modules/position/position.reducer';
import computeLastJob from '$utils/computeLastJob';
import { useEffect, useState } from 'react';

const SPKNotAFitConfirmationModal = () => {
  const dispatch = useAppDispatch();
  const { selectedCandidate, openNotAFitModal } = useAppSelector(
    (state) => state.position
  );
  const [lastJob, setLastJob] = useState<{
    title: string;
    company: string | null;
  }>({
    title: '',
    company: null,
  });

  useEffect(() => {
    if (selectedCandidate?.CandidateWorkExperience?.length) {
      const lj = computeLastJob(selectedCandidate.CandidateWorkExperience);
      setLastJob(lj);
    } else {
      setLastJob({
        title: 'N/A',
        company: null,
      });
    }
  }, [selectedCandidate?.CandidateWorkExperience]);

  return (
    <ModalInTailwind
      isOpen={openNotAFitModal}
      closeModal={() =>
        dispatch(singlePositionSlice.actions.setOpenNotAFitModal(false))
      }
    >
      <ModalCandidateActions
        closeModal={() =>
          dispatch(singlePositionSlice.actions.setOpenNotAFitModal(false))
        }
        img={selectedCandidate?.User?.ProfilePicture?.Url}
        candidateFirstName={selectedCandidate?.User?.FirstName}
        candidateLastName={selectedCandidate?.User?.LastName}
        lastJob={lastJob}
        score={
          selectedCandidate && 'Score' in selectedCandidate
            ? selectedCandidate.Score
            : 0
        }
        handleOk={() => {
          dispatch(singlePositionSlice.actions.setOpenNotAFitModal(false));
          dispatch(singlePositionSlice.actions.setOpenFeedbackModal(true));
        }}
        type="reject"
      />
    </ModalInTailwind>
  );
};

export default SPKNotAFitConfirmationModal;
